import $ from 'jquery';
import events from './events.js';
import * as modals from './modals.js';

function showExitConfirmDialog(url) {
    var pageTracker = window.wizardPageTracker || {};

    if (pageTracker.wizardPage === '3') {
        // Exit questions page 1
        modals.doneConfirmationModal(url);
    } else if (pageTracker.wizardPage === '2') {
        // Exit questions page 2 - Health section
        modals.confirmationModal('Horse Health', url);
    } else {
        // Wizard homepage - horse selection page
        modals.confirmationModal(url);
    }
}

function showExitSectionBackButtonConfirmationDialog(sectionText, url) {
    modals.backConfirmationModal(sectionText, url);
}

function bindConfirmExitEvents() {
    $('body')
        .on('click', '.exit-link', function (e) {
            e.preventDefault();

            showExitConfirmDialog(e.currentTarget.href);
        })
        .on('click', '.health-exit-link', function (e) {
            e.preventDefault();

            showExitSectionBackButtonConfirmationDialog('Horse Health', e.currentTarget.href);
        })
        .on('click', '.about-exit-link', function (e) {
            e.preventDefault();

            showExitSectionBackButtonConfirmationDialog('Basics', e.currentTarget.href);
        });
}

function addBreedPlaceholderText() {
    var $input = $('#Answers_118FreeTextField'),
        placeholderText = 'Please specify breed';

    if ($input.length) {
        $input.attr('placeholder', placeholderText);
    }
}

function setUpSocial() {
    // initialize Google+ buttons
    var po = document.createElement('script'),
        s = document.getElementsByTagName('script')[0];
    po.type = 'text/javascript';
    po.async = true;
    po.src = '//apis.google.com/js/plusone.js';
    s.parentNode.insertBefore(po, s);

    // inject Facebook like button
    $('#socialFacebook').append(
        '<iframe src="//www.facebook.com/plugins/like.php?href=http%3A%2F%2Fwww.smartPakequine.com%2Fhorse-supplement-wizard%2F&amp;send=false&amp;layout=button_count&amp;width=90&amp;show_faces=false&amp;action=like&amp;colorscheme=light&amp;font=arial&amp;height=21&amp;appId=105215512629" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:90px; height:21px;" allowTransparency="true"></iframe>'
    );
}

/*
 * while google+ is async and could be loaded anytime,
 * facebook's like iframe can delay window load.
 * waiting to load these buttons until window load is fired.
 */
export default function initializeWizardCommon() {
    $(window).on('load', setUpSocial);

    $(function () {
        var $container = $('#wizard-container');

        if ($container.length && !$container.hasClass('wizardHasSideBar')) {
            bindConfirmExitEvents();
            events.addExitEventListener();
        }
        addBreedPlaceholderText();
    });
}
